import { Dropdown } from "antd";
import { LogOutIcon, UserRoundIcon } from "lucide-react";
import { Link } from "react-router";
import { getPortalInitials } from "../lib/branding";
import { portalDropdownClassName } from "./PortalSidebar";

export type PortalAccountMenuProps = {
  actorName: string;
  actorEmail: string;
  agencyName?: string;
  profilePath: string;
  onSignOut: () => void;
};

/** Renders the profile avatar with the account dropdown (profile and sign out). */
export const PortalAccountMenu = ({
  actorName,
  actorEmail,
  agencyName,
  profilePath,
  onSignOut,
}: PortalAccountMenuProps) => (
  <Dropdown
    trigger={["click"]}
    placement="bottomRight"
    rootClassName={portalDropdownClassName}
    menu={{
      items: [
        {
          key: "identity",
          disabled: true,
          style: { cursor: "default" },
          label: (
            <div className="min-w-56 py-1">
              {agencyName ? (
                <p className="text-[10px] font-medium uppercase tracking-[0.1em] text-gray-500">{agencyName}</p>
              ) : null}
              <p className="text-sm font-semibold text-[#131B2A]">{actorName}</p>
              <p className="mt-0.5 text-xs text-gray-500">{actorEmail}</p>
            </div>
          ),
        },
        { type: "divider" },
        {
          key: "profile",
          icon: <UserRoundIcon size={15} />,
          label: <Link to={profilePath}>Profile & security</Link>,
        },
        {
          key: "logout",
          icon: <LogOutIcon size={15} />,
          danger: true,
          label: "Sign out",
          onClick: onSignOut,
        },
      ],
    }}
  >
    <button
      type="button"
      aria-label={`Account menu for ${actorName}`}
      className="flex h-10 w-10 items-center justify-center rounded-full bg-(--portal-accent) text-xs font-bold text-(--portal-accent-ink) transition-opacity hover:opacity-90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--brand-primary)/50"
    >
      {getPortalInitials(actorName)}
    </button>
  </Dropdown>
);
